import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../../core/store/store';
import { isPanelTeamMember } from '../panelAccess/panelRoleAccess';

/**
 * Le panel est réservé à l’équipe (rôles 1 à 16). Créateurs de contenu (17)
 * et joueurs (18) n’y ont pas accès.
 */
const PanelTeamOnlyGuard: React.FC = () => {
  const { currentUser } = useSelector((state: RootState) => state.user);
  const roleId = currentUser?.roles_id ?? 0;

  if (!currentUser) {
    return null;
  }

  if (!isPanelTeamMember(roleId)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
};

export default PanelTeamOnlyGuard;
